export enum CarePlanGoalStatus {
  // ED specific statuses
  NOT_STARTED = 'NOT_STARTED',
  PROGRESSING = 'PROGRESSING',
  NOT_PROGRESSING = 'NOT_PROGRESSING',
  COMPLETE = 'COMPLETE',
  VOID = 'VOID',
  NOT_ASSESSED = 'NOT_ASSESSED',

  // Med/Psych statuses
  REPORTED = 'REPORTED',
  STABLE = 'STABLE',
  IMPROVING = 'IMPROVING',
  WORSENING = 'WORSENING',
  RESOLVED = 'RESOLVED',
}

export const TERMINAL_GOAL_STATUSES: readonly CarePlanGoalStatus[] = [
  CarePlanGoalStatus.COMPLETE,
  CarePlanGoalStatus.RESOLVED,
];

export const isTerminalGoalStatus = (status: CarePlanGoalStatus): boolean =>
  TERMINAL_GOAL_STATUSES.includes(status);
